<template>
  <div id="captureZone" class="bg-gray-100 min-h-screen flex flex-col">
    <hijack-bar v-if="isHijacked" />
    <!-- Header -->
    <navbar :key="$root.notificationsCount" />

    <!-- Content container-->
    <slot />

    <app-footer class="mt-auto app-container pb-4" />
    <!-- Modal containers -->
    <div
      v-show="$root.modalOpened"
      class="fixed z-10 inset-0 overflow-y-auto top-14"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
      >
        <!-- Background overlay -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="$root.modalOpened"
            data-html2canvas-ignore
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          />
        </transition>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"
          >&#8203;</span
        >

        <!-- Modal panel -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <component
            v-bind="$page.props"
            :is="$root.asyncModal"
            v-if="$root.modalOpened"
            :modal-data="$root.modalData"
          />
        </transition>
      </div>
    </div>
    <div
      v-show="$root.modal2Opened"
      class="fixed z-10 inset-0 overflow-y-auto top-14"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
      >
        <!-- No overlay for second modal -->
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"
          >&#8203;</span
        >

        <!-- Modal 2 panel -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <component
            v-bind="$page.props"
            :is="$root.asyncModal2"
            v-if="$root.modal2Opened"
            :modal-data="$root.modal2Data"
          />
        </transition>
      </div>
    </div>
    <!-- Slide-over container -->
    <div
      v-show="$root.panelOpened"
      class="fixed inset-0 overflow-hidden"
      role="dialog"
      aria-modal="true"
    >
      <div class="absolute inset-0 overflow-hidden">
        <!-- Background overlay, show/hide based on slide-over state. -->
        <div v-if="$root.panelOpened" class="absolute inset-0" aria-hidden="true">
          <div class="fixed inset-y-0 right-0 pl-10 max-w-full flex sm:pl-16">
            <!-- Slide-over panel, show/hide based on slide-over state. -->
            <transition
              enter-active-class="transition ease-in-out duration-500 sm:duration-700"
              enter-from-class="translate-x-full"
              enter-to-class="translate-x-0"
              leave-active-class="transition ease-in-out duration-500 sm:duration-700"
              leave-from-class="translate-x-0"
              leave-to-class="translate-x-full"
            >
              <component
                v-bind="$page.props"
                :is="$root.asyncPanel"
                v-if="$root.panelOpened"
                :panel-data="$root.panelData"
              />
            </transition>
          </div>
        </div>
      </div>
    </div>
    <!-- Global notification live region, render this permanently at the end of the document -->
    <div
      aria-live="assertive"
      class="fixed inset-x-0 bottom-6 sm:bottom-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50"
    >
      <div class="w-full flex flex-col items-center space-y-4">
        <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
        <transition-group
          enter-active-class="ease-out duration-300 transition"
          enter-from-class="translate-y-2 opacity-0"
          enter-to-class="translate-y-0 opacity-100"
          leave-active-class="transition ease-in duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <toast
            v-for="toast in $toast.state.toasts"
            :id="toast.id"
            :key="toast.id"
            :title="toast.message"
            :type="toast.type"
          />
        </transition-group>
      </div>
    </div>
    <!-- Global notification live region, render this permanently at the end of the document -->
    <div
      aria-live="assertive"
      class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start mt-14"
    >
      <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
        <!-- <transition-group
          enter-active-class="ease-out duration-300 transition"
          enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition ease-in duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        > -->
        <notification-pop-up v-for="notif in $root._notifications" :key="notif.id" :data="notif" />
        <!-- </transition-group> -->
      </div>
    </div>
    <feedback-button v-if="$root.hasRole('manager')" @click="$root.openLocalModal('AddFeedback')" />
  </div>
</template>

<script lang="ts">
import { useFlashToaster } from '@/api/useFlashToaster'
import HijackBar from '@/components/HijackBar.vue'
import FeedbackButton from '@/components/app/FeedbackButton.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import Navbar from '@/components/layout/Navbar.vue'
import NotificationPopUp from '@/components/ui/NotificationPopUp.vue'
import Toast from '@/components/ui/Toast.vue'
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
export default {
  name: 'BaseLayout',
  components: {
    AppFooter,
    HijackBar,
    FeedbackButton,
    Navbar,
    Toast,
    NotificationPopUp,
  },
  inject: ['$toast'],
  setup() {
    const userAvatar = computed(() => usePage().props.user.avatar?.default)
    const isHijacked = computed(() => usePage().props.impersonation_active || false)
    return {
      ...useFlashToaster(),
      userAvatar,
      isHijacked,
    }
  },
}
</script>
